import { Configuration, PublicClientApplication, LogLevel, RedirectRequest, SsoSilentRequest } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || 'YOUR_CLIENT_ID'
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || 'YOUR_TENANT_ID'
const apiScope = import.meta.env.VITE_API_SCOPE || `api://${clientId}/access_as_user`

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
}

const baseScopes = ['openid', 'profile', 'email', apiScope]

export const loginRequest: RedirectRequest = {
  scopes: baseScopes,
}

// Silent SSO using the user's existing browser session at login.microsoftonline.com.
// Used on first load when no cached account exists in localStorage. Will fail when
// the browser blocks third-party cookies or the user has no active session — in
// that case we fall through to interactive login.
export const silentRequest: SsoSilentRequest = {
  scopes: baseScopes,
}

// Interactive login with the Microsoft account picker. Forces Entra to show all
// signed-in accounts in the browser so the user can pick which identity to use.
export const accountPickerRequest: RedirectRequest = {
  scopes: baseScopes,
  prompt: 'select_account',
}

export const apiRequest = {
  scopes: [apiScope],
}

export const msalInstance = new PublicClientApplication(msalConfig)
